import api from '@/shared/config/http.config';
import { ImpersonationMetadata } from '@/shared/config/impersonation.config';
import { ResponseModel } from '@/shared/interfaces/response-model.interface';

export interface StartImpersonationResponse {
  impersonationSessionId: string;
  accessToken: string;
  tokenExpiresIn: number;
  refreshToken: string;
  refreshTokenExpiresIn: number;
  expiresAt: string;
  reason: string;
  actor: ImpersonationMetadata['actor'];
  target: ImpersonationMetadata['target'] & { role?: string[] };
}

export interface ImpersonationRefreshResponse {
  impersonationSessionId: string;
  accessToken: string;
  tokenExpiresIn: number;
  refreshToken: string;
  refreshTokenExpiresIn: number;
  email: string;
  name: string;
  userId: string;
  role?: string[];
}

export const impersonationApiService = {
  async start(targetUserId: string, reason: string): Promise<StartImpersonationResponse> {
    const response = await api.post<ResponseModel<StartImpersonationResponse>>(
      '/auth/impersonation/start',
      { targetUserId, reason }
    );
    if (!response.ok || !response.data?.data) {
      throw new Error(
        response.data?.message || response.problem || 'Failed to start impersonation'
      );
    }
    return response.data.data;
  },

  async stop(sessionId: string): Promise<void> {
    const response = await api.post('/auth/impersonation/stop', { sessionId });
    if (!response.ok) {
      throw new Error(response.data?.message || response.problem || 'Failed to stop impersonation');
    }
  },

  async refresh(sessionId: string, refreshToken: string): Promise<ImpersonationRefreshResponse> {
    const response = await api.post<ResponseModel<ImpersonationRefreshResponse>>(
      '/auth/impersonation/refreshToken',
      { sessionId, refreshToken }
    );
    if (!response.ok || !response.data?.data) {
      throw new Error(
        response.data?.message || response.problem || 'Failed to refresh impersonation session'
      );
    }
    return response.data.data;
  }
};
